import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BtnEditar } from '../../general/BotonesAccion';
import ListarDatos from '../../general/ListarDatos';
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';
import { obtenerValoresFiltros } from '../../../global/js/funciones';
import moment from 'moment';
import { connect } from 'react-redux';
import { actualizarMensaje } from '../../../redux/actions/actGlobal';
import {
    mostrarModalAddValores,
    mostrarModalModValores,
    actualizarDataValor,
} from '../../../redux/actions/actValores';
import {
    guardarValorGenerica,
    mostrarError,
    modificarValorGenerica,
} from '../../../global/js/funciones';

//COMPONENTES DEL MODULO
import ValoresAgregar from '../../genericas/valores/ValoresAgregar';
import ValoresModificar from '../../genericas/valores/ValoresModificar';


class InvitadosValoresGenericas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cargando: true,
            modal: false,
            valores: []
        };
    }
    async componentDidMount() {
        this.cargarValores();
    }

    async cargarValores() {
        let { idGenerica } = this.props;
        let valores = await obtenerValoresFiltros([
            { 'llave': 'generica', 'valor': idGenerica },
            { 'llave': 'estado', 'valor': '1' }
        ])
        this.setState({ valores, cargando: false });
    }


    guardarValor = async (
        codigo,
        nombre,
        descripcion,
        valora,
        valorb,
        valorc,
        valord,
        valore,
        valorf,
        valorg,
        archivo,
        valorh,
    ) => {
        let { actualizarMensaje, mostrarModalAddValores, idGenerica } = this.props;
        let { error, estado, resp } = await guardarValorGenerica(
            idGenerica,
            codigo.toUpperCase(),
            nombre.toUpperCase(),
            descripcion,
            valora,
            valorb,
            valorc,
            valord,
            valore,
            valorf,
            valorg,
            archivo,
            valorh,
        );
        let titulo = 'Ha ocurrido un error, contacte con el administrador.',
            tipo = 'error';
        if (!error) {
            if (estado === 200) {
                tipo = 'success';
                titulo = resp.titulo;
                this.cargarValores();
                mostrarModalAddValores(false);
            } else {
                tipo = 'info';
                titulo = resp.titulo ? resp.titulo : mostrarError(resp);
            }
        }
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    };

    modificarValor = async (
        id,
        codigo,
        nombre,
        descripcion,
        valora,
        valorb,
        valorc,
        valord,
        valore,
        valorf,
        valorg,
        valorh,
        archivo
    ) => {
        console.log(nombre)
        let { actualizarMensaje, mostrarModalModValores } = this.props;
        let { error, estado, resp } = await modificarValorGenerica(
            id,
            codigo.toUpperCase(),
            nombre.toUpperCase(),
            descripcion,
            valora,
            valorb,
            valorc,
            valord,
            valore,
            valorf,
            valorg,
            valorh,
            archivo
        );
        let titulo = 'Ha ocurrido un error, contacte con el administrador.',
            tipo = 'error';
        if (!error) {
            if (estado === 200) {
                tipo = 'success';
                titulo = resp.titulo;
                this.cargarValores();
                mostrarModalModValores(false);
            } else {
                tipo = 'info';
                titulo = resp.titulo ? resp.titulo : mostrarError(resp);
            }
        }
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    };



    render() {

        let {
            valor,
            mostrarModalModValores,
            actualizarDataValor,
            mostrarModalAddValores,
            modalAddValores,
            modalModValores,
        } = this.props;

        const config = () => {
            return {
                inputCodigo: { label: 'Codigo', mostrar: true, tipo: 'text', requerido: true },
                inputNombre: { label: 'Asignatura', mostrar: true, tipo: 'text', requerido: true },
                inputDescripcion: { label: 'Descripción', mostrar: false, tipo: 'text', requerido: false },
                inputValora: { label: 'Codigo', mostrar: false, tipo: 'text', requerido: false },
                inputValorb: { label: 'Precio', mostrar: false, tipo: 'text', requerido: false },
                inputValorc: { label: 'Programas', mostrar: false, tipo: 'text', requerido: false },
                inputValord: { label: 'Valor D', mostrar: false, tipo: 'date', requerido: false },
                inputValore: { label: 'Valor E', mostrar: false, tipo: 'text', requerido: false },
                inputValorf: { label: 'Valor F', mostrar: false, tipo: 'text', requerido: false },
                inputValorg: { label: 'Valor G', mostrar: false, tipo: 'switch', requerido: false },
                inputValorh: { label: 'Valor H', mostrar: false, tipo: 'switch', requerido: false },
                inputValori: { label: 'Valor I', mostrar: false, tipo: 'text', requerido: false },
                inputArchivo: { label: 'Adjuntar Archivo', mostrar: false, tipo: 'file', requerido: false }
            };
        };

        const actions = (rowData) => {
            const onClickEditar = (data) => {
                console.log('a2ui')
                actualizarDataValor(data);
                mostrarModalModValores(true);
            }
            return <BtnEditar callback={() => onClickEditar(rowData)} />;
        }

        const { cargando, valores } = this.state;
        if (cargando) return <TareasTerminadas mensaje="Cargando.." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true}/>;
        return (
            <>
                <ListarDatos
                    datos={valores}
                    titulo="Lista de Asignaturas"
                    buscar={true}
                    agregar={true}
                    opciones={true}
                    descargar=""
                    acciones={(row) => actions(row)}
                    actAgregar={() => mostrarModalAddValores(true)}
                    id="tbl_asig_invi"
                    fila_principal={({ nombre }) => nombre}
                    filas={[
                        {
                            'mostrar': ({ codigo }) => codigo,
                            'id': 'codigo_asig',
                            'enLista': true
                        },
                        {
                            'mostrar': ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'),
                            'id': 'fecha_registro_asi',
                            'enLista': true
                        }
                    ]}
                />

                <ValoresAgregar
                    mostrarABC={true}
                    modalAddValores={modalAddValores}
                    mostrarModalAddValores={mostrarModalAddValores}
                    guardarValor={this.guardarValor}
                    inputs={config()}
                    titulo={'¡Nueva Asignatura!'}
                />
                <ValoresModificar
                    // titulo={'¡ Modificar Asignatura !'}
                    mostrarABC={true}
                    modalModValores={modalModValores}
                    mostrarModalModValores={mostrarModalModValores}
                    valor={valor}
                    modificarValor={this.modificarValor}
                    inputs={config()}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    let {
        modalAddValores,
        modalModValores,
        valor
    } = state.redValores;
    return {
        modalAddValores,
        modalModValores,
        valor
    };
};

const mapDispatchToProps = {

    actualizarDataValor,
    mostrarModalModValores,
    mostrarModalAddValores,
    actualizarMensaje
};


export default connect(mapStateToProps, mapDispatchToProps)(InvitadosValoresGenericas);


